/*
 * Broadcast Theme
 *
 * Use this file to add custom Javascript to Broadcast.  Keeping your custom
 * Javascript in this fill will make it easier to update Broadcast. In order
 * to use this file you will need to open layout/theme.liquid and uncomment
 * the custom.js script import line near the bottom of the file.
 */

(function () {
  // Add custom code below this line

  // <!-- Accessibility -->

  window.args = {
    sitekey: "3e68cfaa9143c8e03aede63bcc1b2506",
    position: "left",
    language: "HE",
    container: "",
    icon: "",
    access: "https://vee-crm.com",
    styles: {
      primary_color: "#614833",
      secondary_color: "#b586ff",
      background_color: "#f6f6f6",
      primary_text_color: "#636363",
      headers_text_color: "#105675",
      primary_font_size: 14,
      slider_left_color: "#b586ff",
      slider_right_color: "#177fab",
      icon_vertical_position: "bottom",
      icon_offset_top: 100,
      icon_offset_bottom: 10,
      highlight_focus_color: "#177fab",
      toggler_icon_color: "#ffffff",
    },
    links: {
      acc_policy:
        "https://oliereparis.com/pages/%D7%94%D7%A6%D7%94%D7%A8%D7%AA-%D7%A0%D7%92%D7%99%D7%A9%D7%95%D7%AA",
      additional_link: "https://vee.co.il/pricing/",
    },
    options: {
      open: false,
      aaa: false,
      hide_tablet: false,
      hide_mobile: false,
      button_size_tablet: 54,
      button_size_mobile: 54,
      position_tablet: "left",
      position_mobile: "left",
      icon_vertical_position_tablet: "bottom",
      icon_vertical_position_mobile: "bottom",
      icon_offset_top_tablet: 100,
      icon_offset_bottom_tablet: 10,
      icon_offset_top_mobile: 100,
      icon_offset_bottom_mobile: 10,
      keyboard_shortcut: true,
      hide_purchase_link: false,
      display_checkmark_icon: false,
      active_toggler_color: "#118f38",
    },
    // Optional, values: high-contast, negative, grayscale, black-white, highlight-links, keyboard-navigation, text, word-spacing, letter-spacing, readable-text, alt, cursor, reading, animations, highlight-titles (Use Quotes, comma seperated)
    exclude: [],
  };

  (function (doc, head, body) {
    var embed = doc.createElement("script");
    embed.src = window.args["access"] + "/js/";
    embed.defer = true;
    embed.crossOrigin = "anonymous";
    embed.setAttribute("data-cfasync", true);
    body ? body.appendChild(embed) : head.appendChild(embed);
  })(document, document.head, document.body);

  // ^^ Keep your scripts inside this IIFE function call to
  // avoid leaking your variables into the global scope.
})();
